//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiMinus,
  mdiAccountCircleOutline,
  mdiPlus,
  mdiFormatListBulletedSquare,
  mdiGreasePencil,
  mdiAndroid,
} from '@mdi/js'

export default {
  setup() {
    return {
      icons: {
        mdiMinus,
        mdiAccountCircleOutline,
        mdiPlus,
        mdiFormatListBulletedSquare,
        mdiGreasePencil,
        mdiAndroid,
      },
    }
  },
}
